import React from 'react';
import { Helmet } from 'react-helmet';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleButton from 'components/RoleButton';
import RoleGate from 'components/RoleGate';
import { ADMIN } from 'components/RoleGate/constants';
import PageTitleAndFilters from 'components/PageTitleAndFilters';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';

// Child Components
// @ts-ignore
import CreateWorkTypeModal from './components/CreateWorkTypeModal';
// @ts-ignore
import WorkTypeDeleteModal from './components/WorkTypeDeleteModal';
// @ts-ignore
import WorkTypesTable from './components/WorkTypesTable';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const Tasks = (): React.ReactElement => (
    <ErrorBoundary namespace="Tasks" FallbackComponent={<ErrorBoundaryAlert />}>
        <Helmet>
            <title>
                {'Tasks - '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <PageTitleAndFilters
            title="Tasks"
            Button={
                <RoleButton
                    requiredRoles={[ADMIN]}
                    params={{
                        createWorkTypeModal: true
                    }}
                >
                    Create Task
                </RoleButton>
            }
            searchInputPlaceholder="Search tasks"
            hideFilters
        />
        <PageWrapper top={0} bottom={50}>
            <WorkTypesTable />
        </PageWrapper>
        <RoleGate requiredRoles={[ADMIN]}>
            <CreateWorkTypeModal />
        </RoleGate>
        <RoleGate requiredRoles={[ADMIN]}>
            <WorkTypeDeleteModal />
        </RoleGate>
    </ErrorBoundary>
);

export default Tasks;
